import $ from "jquery";
import { addressFormatter } from "../framework/addressFormatter";
import { countryState } from "./countryState";
import { course } from "./course";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import intlTelInput from 'intl-tel-input';

let itiPhone = {};
let itiFax = {};
function init() {
    countryState.populateCountriesSelect("#AddPersonCountrySelect", "#NaStateSelection");
    setEvents();
}

function setEvents() {
    $("#Military").on("change", function() {
        calculateRegionId();
    });

    $("#AddPersonStateSelect").change(function() {
        calculateRegionId();
    });

    $("#AddPersonCountrySelect").change(function() {
        const selectedCountry = $(this).val();
        itiPhone.setCountry(selectedCountry);
        itiFax.setCountry(selectedCountry);
        countryState.populateStatesSelect(
            "#NaStateSelection",
            "#NonNaStateSection",
            selectedCountry
        );
        addressFormatter.maskPhone($("#addPersonPhoneNumber, #Fax"), selectedCountry);
        addressFormatter.maskZip($("#addPersonPostalCode"), selectedCountry);
        addressFormatter.showIfUsOrCa($("#NaStateSelection"), selectedCountry);
        addressFormatter.showIfNotUsOrCa($("#NonNaStateSection"), selectedCountry);

        if (addressFormatter.isUsOrCa(selectedCountry)) {
            $("#NonNaState").val("");
        }
        calculateRegionId();
    });

    $("#addNewPerson").on("hidden.bs.modal", function (e) {      
       $(this)
            .find("input:not([type=hidden],[id=City], [type=radio], [type=checkbox]), textarea, select").val("").end()
           .find("input[type=checkbox], input[type=radio]").prop("checked", false).end();
    });

    $("#addNewPerson").on("shown.bs.modal", function (e) {      
        const selectedCountry = $("#hdnCountryCode").val();        
        $("#AddPersonCountrySelect").val(selectedCountry).change();
        $("#AddPersonStateSelect").val($("#hdnStateId").val()).change();
    });    
   

    $("#person-submit").click(function() {
        $("#arearequiredspan").addClass("hidden");
        if ($("#AddPersonAreaSelect option").length > 1) {
            if ($("#AddPersonAreaSelect").val() < 1) {
                $("#arearequiredspan").removeClass("hidden");
                return;
            }
        };

        const $form = $(this).closest("form");

        if ($form.valid()) {

            if ($("#AddPersontxtRegionId").val() === "") {
                //If empty then Region is not set.
                //Region will be calculated again and Area marked as required.
                calculateRegionId();
                $("#arearequiredspan").removeClass("hidden");
                return;
            }

            if ($("#IsStudentRoster").val() === "True") {
                forms.disableSubmitButton();

                const params = {
                    contentType: dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
                    data: $form.serialize(),
                    url: $form.attr("action"),
                    successMsg: "Successfully saved."
                };

                dataaccess
                    .post(params)
                    .done(function(result) {
                        dataaccess
                            .post({
                                url:
                                    "/Course/AddStudent/" +
                                    result.personId +
                                    "/" +
                                    result.courseId +
                                    "/Student"
                            })
                            .done(function() {
                                course.populateStudentTable();
                                forms.enableSubmitButton();
                                $("#addNewPerson").modal("hide");
                                $("#AddPersonRoleSelect")
                                    .val("default")
                                    .selectpicker("refresh");
                            });
                    })
                    .fail(function() {
                        forms.enableSubmitButton();
                    });
            } else {
                forms.disableSubmitButton();
                $form.submit();
            }
        }
    });

    $("#addNewPersonButton").click(function () {        
        $("#btnBasicInfoEdit .fa-times").click();

    });

    itiPhone = intlTelInput(document.querySelector("#addPersonPhoneNumber"), {utilsScript:"/dist/utils.js"});
    itiFax = intlTelInput(document.querySelector("#addPersonFaxNumber"), { utilsScript: "/dist/utils.js" });
}



function calculateRegionId() {
    const militaryValue = $("#Military").is(":checked");
    const countryCodeValue = $("#AddPersonCountrySelect").val();
    if (countryCodeValue === "") {
        return;
    }
    let stateIdValue = $("#AddPersonStateSelect").val();
    if (stateIdValue === "") {
        stateIdValue = "0";
    }
    dataaccess
        .get({
            url:
                "/api/Region/GetRegionId/" + militaryValue + "/" + countryCodeValue + "/" + stateIdValue
        })
        .done(function(result) {
            $("#AddPersonhdnRegionId").val(result);
            $("#AddPersontxtRegionId").val(result);
            loadAreas(result);
        })
        .fail(function() {
            $("#AddPersonhdnRegionId").val(0);
            $("#AddPersontxtRegionId").val(0);
            loadAreas(0);
        });
}

function loadAreas(regionId) {
    const countryCodeValue = $("#AddPersonCountrySelect").val();
    let stateIdValue = $("#AddPersonStateSelect").val();
    if (stateIdValue === "") {
        stateIdValue = "0";
    }
    $("#AddPersonAreaSelect").find("option").not(":first").remove().end();
    dataaccess
        .get({
            url:
                "/api/area/GetAreasForRegionId/" + regionId + "/" + countryCodeValue + "/" + stateIdValue
        })
        .done(function(results) {
            for (let i = 0; i < results.length; i++) {
                if (results[i].selected === true) {
                    $("#AddPersonAreaSelect").append("<option value='" + results[i].areaId + "' selected>" + results[i].areaName + "</option>");
                } else {
                    $("#AddPersonAreaSelect").append("<option value='" + results[i].areaId + "'>" + results[i].areaName + "</option>");
                }
            }
        })
        .fail(function() {
            $("#AddPersonAreaSelect").append("<option value='" + 0 + "'>" + "Error Getting Areas" + "</option>");
        });
}

export const addPerson = {
    init: init
};
